<template>
  <textarea tabindex="2" ref="tata" :class="{ focused: focused }" @focus="$emit('focus')" @blur="$emit('blur')" :rows="1" :cols="20" class="ta" type="text" v-model="text" placeholder="message" @input="$emit('text', { text })" />
</template>

<script>
export default {
  props: {
    focused: {}
  },
  data () {
    return {
      text: ''
    }
  },
  mounted () {
    // this.$refs['tata'].focus()
  }
}
</script>

<style scoped>
.ta{
  display: inline-block;
  height: 40px;
  width: calc(100% - 130px);
  margin-bottom: 0px;
  border-radius: 0px;
}

.focused.ta{
  height: 80px;
}
@media screen and (min-width: 767px) {
  .ta{
    height: 40px;
  }
  .focused.ta{
    height: 40px;
  }
}
</style>
